import type { OrderSearchType } from './entities/order';

export const SEARCH_ENGINES = ['algolia', 'typesense'] as const;
export type SearchEngine = (typeof SEARCH_ENGINES)[number];

/** The engine an org searches on when its `searchEngine` flag is unset, unreadable or names no engine. */
export const DEFAULT_SEARCH_ENGINE: SearchEngine = 'algolia';

export const isSearchEngine = (value: unknown): value is SearchEngine =>
  SEARCH_ENGINES.some((engine) => engine === value);
export type SearchKeyDomain = 'orders' | 'general';

export interface OrderPermissions {
  readonly viewSalesOrders: boolean;
  readonly viewPurchaseOrders: boolean;
  readonly viewWorkOrders: boolean;
}

export interface SearchCredentials {
  readonly engine: SearchEngine;
  readonly endpoint: string;
  readonly keys: { readonly orders?: string; readonly general: string | null };
  /** The collections the member may search, each covered by a minted key. Both engines fill it. */
  readonly collections?: readonly string[];
  readonly expiresAt: string;
}

export const SEARCH_KEY_TTL_SECONDS = 15 * 60;

const ORDERS_COLLECTION = 'orders';

export function allowedOrderTypes(p: OrderPermissions): readonly OrderSearchType[] {
  const types: OrderSearchType[] = [];
  if (p.viewSalesOrders) types.push('SalesOrder');
  if (p.viewPurchaseOrders) types.push('PurchaseOrder');
  if (p.viewWorkOrders) types.push('WorkOrder');
  if (p.viewSalesOrders && p.viewPurchaseOrders) types.push('BuySellOrder');
  return types;
}

export function keyDomainFor(collection: string): SearchKeyDomain {
  return collection === ORDERS_COLLECTION ? 'orders' : 'general';
}
